import { FC, memo } from 'react';

import { ColumnsProps } from './types/ColumnsProps';

const ColumnsComponent: FC<ColumnsProps> = () => <>columns</>;

export const Columns = memo(ColumnsComponent);
